export default __webpack_public_path__ + "static/media/4.7260a844.png";